import axiosClient from "../axiosClient";
import { cachedRequest } from "../../utils/apiCache";

export function getAllStories(data, pathOverride, options = {}) {
  // Support getAllStories(data, { useCache: false })
  if (pathOverride && typeof pathOverride === "object") {
    options = pathOverride;
    pathOverride = undefined;
  }

  let bearerTokenHeader = sessionStorage.getItem("accessToken"); //Gets the user's JWT access token from browser sessionStorage.
  if (bearerTokenHeader) {
    axiosClient.defaults.headers.common["Authorization"] =
      `Bearer ${bearerTokenHeader}`; //adds bearer token to the request header
    //Authorization: Bearer eyJhbGciOi...
  }
  let path = pathOverride || window.location.pathname;
  const request = () =>
    path === "/" || path === "/home"
      ? axiosClient.post("/home/stories/all", JSON.stringify(data))
      : axiosClient.post("/stories/all", JSON.stringify(data));

  if (options.useCache === false) return request();

  if (path === "/" || path === "/home") {
    return cachedRequest(
      `stories:home:${JSON.stringify(data || {})}`,
      request,
      { force: options.force === true },
    );
  }
  return cachedRequest(`stories:all:${JSON.stringify(data || {})}`, request, {
    force: options.force === true,
  });
}

//for single story
export function getSingleStory(id) {
  let bearerTokenHeader = sessionStorage.getItem("accessToken");
  if (bearerTokenHeader) {
    axiosClient.defaults.headers.common["Authorization"] =
      `Bearer ${bearerTokenHeader}`;
  }
  return axiosClient.get(`/stories/view/${id}`);
}
// extra fuction remove later.
// export function storyViewed(id){
//     let bearerTokenHeader = sessionStorage.getItem('token');
//     if(bearerTokenHeader){
//         axiosClient.defaults.headers.common['Authorization'] = `Bearer ${bearerTokenHeader}`;
//     }
//     return axiosClient.get(`/stories/view/${id}`);
// }
